import DeleteIcon from '@mui/icons-material/Delete';
import Modal, { ModalTypes } from '@/trio-ui/Modal';
import * as Styles from './DeleteConfirmationModal.styles';

type DeleteConfirmationModalProps = Pick<
  ModalTypes,
  | 'onClose'
  | 'isOpen'
  | 'isButtonDisabled'
  | 'hideConfirmButton'
  | 'modalTitle'
  | 'hideCancelButton'
> & {
  onConfirmHandler: () => void;
  onConfirmLabel?: string;
  bodyMessage?: string;
};

export default function DeleteConfirmationModal({
  onConfirmHandler,
  onConfirmLabel = 'Yes, delete it',
  bodyMessage = 'This action cannot be undone.',
  ...props
}: DeleteConfirmationModalProps): JSX.Element {
  const BodyMessage = <Styles.Message>{bodyMessage}</Styles.Message>;

  return (
    <Modal
      modalId="delete-confirmation-modal"
      headerIcon={DeleteIcon}
      isCentered
      size="sm"
      modalTitle="Are you sure?"
      bodyRender={BodyMessage}
      onConfirmLabel={onConfirmLabel}
      onConfirmButtonVariant="red"
      onConfirmClick={onConfirmHandler}
      {...props}
    />
  );
}
